export const environment = {
  production: false,
  baseUrl: 'https://devapi.anikinitek.com/assetmgmtdev/',
  cid: 1793704423358,
  razorpayKey: 'rzp_test_zOmYjCNx9hxf8X',
  company: 'amuldigital',
  companyName: 'Amul Digital'
};

